import React from 'react';
import AdminLayout from './AdminLayout';
import AdminUnifiedInboxTab from '../../components/admin/inbox/AdminUnifiedInboxTab';

export default function AdminUnifiedInboxPage() {
    return (
        <AdminLayout title="Unified Inbox" description="Configure unified inbox settings">
            <AdminUnifiedInboxTab />
        </AdminLayout>
    );
}
